import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const island = defineConnector({
  identifier: "island",
  name: "Island",
  tagLine: "Enterprise browser security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.island\\.io/.*",
  auth: (app) => headerAuth([{ name: "Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key in Island",
      items: [
        {
          kind: "markdown",
          content: `1. In the Island Management Console, go to **Modules › Platform Settings › System Settings › Integrations › API**
2. Generate a new API key
3. Copy the key`,
        },
      ],
    },
    {
      title: "Enter your Island details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://management.island.io/api/v1/devices?limit=1",
  },
});
